import { IOffer } from '../../../types/offer';

export function getCommercialFloorLabel(offer: IOffer): string | undefined {
  const floorNumber = offer.floorNumber;
  const floorsCount = offer.building?.floorsCount;

  if (floorNumber == null) {
    return undefined;
  }

  if (floorsCount) {
    return `${floorNumber}/${floorsCount} этаж`;
  }

  return `${floorNumber} этаж`;
}
